import Flex from 'typescript-styled-flex'
import styled from '../../../../../theme'
import { IWithSize } from '../../../Calendar/Calendar'

const Footer = styled(Flex.withComponent('footer') as any)<IWithSize>`
  border-top: 1px solid #d7d7d7;

  position: sticky;
  padding: ${({ size }) => (size ? size : 1)}em;
`

export default Footer
